import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { lighten } from '@mui/system';
import { FC } from 'react';

import { getColorFromIndex } from '../../utils';
import { colorLightenFactor } from '../styles';

interface Props {
  slotHeightRem: number;
  slot: number;
  colorIndex?: number;
  nickname?: string;
  showSlotLabel?: boolean;
  flip?: boolean;
}

export const LabwareSlotItem: FC<Props> = (props) => {
  const { slotHeightRem, colorIndex, nickname, slot, showSlotLabel, flip } =
    props;
  const color = colorIndex !== undefined ? getColorFromIndex(colorIndex) : null;
  return (
    <Box
      position="relative"
      sx={{
        height: `${slotHeightRem}rem`,
        width: `${(slotHeightRem * 3) / 2}rem`,
        backgroundColor:
          color !== null ? lighten(color, colorLightenFactor) : 'white',
        padding: '0.25rem',
        borderColor: 'grey.400',
        borderRadius: '5px',
        borderStyle: 'solid',
        borderWidth: '1px',
        textAlign: 'center',
        transform: flip ? 'rotate(0.5turn)' : undefined,
      }}
    >
      {showSlotLabel ? (
        <Typography
          component="div"
          variant="body2"
          position="absolute"
          sx={{
            margin: 'auto 0',
            color: 'grey.600',
            right: '0.5rem',
            top: '0.5rem',
          }}
        >
          {slot}
        </Typography>
      ) : null}

      <Stack height="100%" justifyContent="center">
        <Typography component="div" variant="caption" textOverflow="ellipsis">
          {nickname}
        </Typography>
      </Stack>
    </Box>
  );
};
